/**
 * testGround.jsx
 * rsvp message handler
 * sends, gets, and renders rsvp messages
 */
import React, {useState, useEffect} from 'react';
import axios from 'axios';
import Message from './message';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import '../../style/eventDetails.css';
/**
 * @param eventid = the event id that the message is assigned to
 * @param contactid = contact id of the contact who created the message
 */
function TestGround({eventid, contactid}) {
    const [message, setMessage] = useState([]);
    const [noMessage, setNoMessage] = useState(false);
    const [sendMsg, setSendMsg] = useState("");
    /**
     * function getMessage()
     * gets the rsvp message for a certain event
     */
    async function getMessage() {
        const eventID = eventid;
        try {
            const mesgRes = await axios.get(`https://link2rsvp.herokuapp.com/event/getMessages/${eventID}`);
            setMessage(mesgRes.data);
            console.log(mesgRes.data.length);
            //checking to see if messages is empty, if so will display "no messages"
            if(mesgRes.data.length > 0){
                setNoMessage(false);
            } else {
                setNoMessage(true);
            }
        } catch (err) {
            if(err.response) {
                if(err.reponse.data.errorMessage) {
                    console.log(err.response.data.errorMessage);
                }
            }
        }
    };
    /**
     * function renderMessage()
     * takes messages from an event and maps then to render
     */
    function renderMessage() {
        return (
            message.map((message, i) =>{ return <Message key={i}
                                                        message={message}
                                                        contactid={contactid}
                                                        />})
        );
    }
    /**
     * function sendMesg()
     * will save the rsvp message
     */
    async function sendMesg(e) {
        e.preventDefault();
        //setting the date and time of the message
        let today = new Date();
        let hour = today.getHours();
        //getting the hour of the message
        if(hour < 10) {
            hour = '0'+hour;
        }
        let minutes = today.getMinutes();
        //getting the mintues of the message
        if(minutes < 10){
            minutes = '0'+minutes;
        }
        const timeCurrent = hour+':'+minutes;
        //message data that will be sent to the server
        const mesgData = {
            eventid: eventid,
            contactid: contactid,
            message: sendMsg,
            time: timeCurrent
        }
        //sending the message to server to be saved
        try {
            await axios.post("https://link2rsvp.herokuapp.com/event/message", mesgData);
            setSendMsg("");
            getMessage();
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() =>{
       getMessage();
       //eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    return (
        <div>
            <div style={{height: 200, overflowY: 'scroll', backgroundColor: "rgb(300, 300, 300)"}} className="message-div">
                {renderMessage()}
                {
                    noMessage && (
                        <p style={{margin: "auto", textAlign: "center"}}>No Messages currently</p>
                    )
                }
            </div>
            <span>
            <form onSubmit={sendMesg}>
                    <Form.Group className='mb-3' id="sendMsg">
                        <Form.Label htmlFor="msgInput"></Form.Label>
                        <Form.Control
                        type="text"
                        name="msgInput"
                        placeholder="Enter your message"
                        value={sendMsg}
                        onChange={(e) => setSendMsg(e.target.value)}
                        required
                        />
                    </Form.Group>
                    <Button
                    id="send-btn"
                    variant="secondary"
                    style={{backgroundColor: "#890E32", margin: "auto", width: "50%"}}
                    type="submit"
                    >Send</Button>
                </form>
            </span>
        </div>
    )
}

export default TestGround;